module.exports = __webpack_public_path__ + "static/img/medal_top3.b6edb4f4.png";